import { render, staticRenderFns } from "./professions.vue?vue&type=template&id=73f58aca&scoped=true"
import script from "./professions.vue?vue&type=script&lang=js"
export * from "./professions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f58aca",
  null
  
)

export default component.exports